/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Invoice_Before_ShipmentInputs */

const en_error_invoice_before_shipment = /** @type {(inputs: Error_Invoice_Before_ShipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This shipment is invoiced after it leaves, on the units shipped: it has not left yet.`)
};

/**
* | output |
* | --- |
* | "This shipment is invoiced after it leaves, on the units shipped: it has not left yet." |
*
* @param {Error_Invoice_Before_ShipmentInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_invoice_before_shipment = /** @type {((inputs?: Error_Invoice_Before_ShipmentInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Invoice_Before_ShipmentInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_invoice_before_shipment(inputs)
});